<template>
  <action-person-template :action="action" column="person" grid="person" title="Buteur"/>
</template>

<script>
import ActionPersonTemplate from './ActionPersonTemplate'

export default {
  name: 'SportFootballMatchActionPersonStriker',
  props: {
    action: Object
  },
  components: { ActionPersonTemplate }
}
</script>
